import React from 'react';
import block from 'bem-cn';
import PT from 'prop-types';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';

import SVG from 'components/SVG';

import arrowSVG from './img/arrow.svg';

import './BackBlock.scss';

const b = block('back-block');

const BackBlock = ({ children, route }) => {
  const history = useHistory();

  const { locale } = useSelector(state => state.locale);

  const pushRoute = () => (route ? history.push(route) : history.goBack());

  return (
    <div className={b()} onClick={() => pushRoute()}>
      <SVG className={b('arrow')} svgProps={{ svg: arrowSVG }} />
      <div className={b('content')}>{children || locale.back}</div>
    </div>
  );
};

BackBlock.propTypes = {
  children: PT.any,
  route: PT.string,
};

export default BackBlock;
